<div
  class="okr-design-score"
  #okrDesignScore
  [uiVisible]="isPopoverOpen"
  [uiTrigger]="'click'"
  [uiTitle]="titleTemplate"
  [uiContent]="contentTemplate"
  [uiPlacement]="'bottom'"
  [uiBackdrop]="true"
  [attr.aria-labelledby]="a11yLabelledby"
  (keydown.enter)="onEnterKeydown()"
  ui-popover
  role="button"
  aria-haspopup="true"
  aria-keyshortcuts="Enter"
  tabindex="0">
  <div
    class="ball sp-mr-3"
    *ngFor="let n of balls"
    [ngClass]="{
      'half-fill': designScore.totalPoints > n * ballValue && designScore.totalPoints <= n * ballValue + offset,
      'full-fill': designScore.totalPoints > n * ballValue + offset && designScore.totalPoints !== totalPoints,
      completed: designScore.totalPoints === 100
    }"></div>

  <i class="fs-14px" ui-icon uiType="arrow-down-small"></i>
</div>

<ng-template #titleTemplate>
  <div id="okr-design-popover-title" (keydown.escape)="keydownEscClosePopover($event)" aria-keyshortcuts="Escape" tabindex="0">{{ "okr_design_score" | localize }}</div>
</ng-template>

<ng-template #contentTemplate>
  <div class="okr-design-popover" (keydown.escape)="keydownEscClosePopover($event)" aria-keyshortcuts="Escape">
    <div class="content">
      <div class="text">
        <div class="description" *ngIf="designScore.totalPoints < 100" [innerHTML]="'okr_assistant_description' | localize" tabindex="0"></div>
        <div class="description" *ngIf="designScore.totalPoints === 100" [innerHTML]="'okr_assistant_description_full_points' | localize" tabindex="0"></div>
      </div>

      <ui-progress
        [uiPercent]="designScore.totalPoints"
        [uiFormat]="formatScore"
        [uiWidth]="80"
        [uiStrokeWidth]="9.5"
        [attr.aria-label]="(a11yLabelledby | localize) + ' ' + designScore.totalPoints"
        uiType="circle"
        tabindex="0"></ui-progress>
    </div>

    <div class="policies">
      <div *ngFor="let policy of policies">
        <div class="policy" *ngIf="policy.shouldRender" tabindex="0">
          <div class="status">
            <div class="status-true" *ngIf="policy.isPassed" [attr.aria-label]="('passed' | localize) + ' ' + policy.title">
              <i ui-icon uiType="check"></i>
            </div>
            <div class="status-false" *ngIf="!policy.isPassed" [attr.aria-label]="('failed' | localize) + ' ' + policy.title">!</div>
          </div>

          <div class="title" aria-hidden="true">
            {{ policy.title }}
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div tabindex="0">{{ "was_this_helpful" | localize }}</div>

      <button class="emoticon-btn" [attr.aria-label]="'yes' | localize" (click)="emoticonClick('like')" ui-button uiType="link" tabindex="0">
        <div class="nc-icon-mini icon emoticons_like"></div>
      </button>

      <button
        class="emoticon-btn"
        [attr.aria-label]="'no' | localize"
        (click)="emoticonClick('dislike')"
        (keydown.tab)="keydownTabOnLastElem()"
        aria-keyshortcuts="Tab"
        ui-button
        uiType="link"
        tabindex="0">
        <div class="nc-icon-mini icon emoticons_like-no"></div>
      </button>
    </div>
  </div>
</ng-template>
